import type { PageMeta } from "./en";

const hi: Record<string, PageMeta> = {
  astrologers: {
    title: "AI ज्योतिषी ऑनलाइन | निःशुल्क वैदिक AI ज्योतिषी (पंडित-जी) | Ishvaram",
    description:
      "Ishvaram के AI वैदिक ज्योतिषी — पराशरी परंपरा में प्रशिक्षित। आपकी पूरी कुंडली पढ़कर हर सवाल का जवाब। 24/7 निःशुल्क।",
    keywords: [
      "ज्योतिषी",
      "AI ज्योतिषी",
      "ऑनलाइन ज्योतिषी",
      "निःशुल्क ज्योतिषी",
      "वैदिक ज्योतिषी",
      "astrologer hindi",
    ],
    ogTitle: "निःशुल्क AI ज्योतिषी — अभी बात करें | Ishvaram",
    ogDescription: "पराशरी, नाड़ी, लाल किताब ज्योतिषी — 24/7 निःशुल्क, आपकी कुंडली पहले से लोड।",
  },
  pandits: {
    title: "AI पंडित जी ऑनलाइन | दोष निवारण और शुभ मुहूर्त | Ishvaram",
    description:
      "AI पंडित जी से निःशुल्क परामर्श — दोष निवारण, शुभ मुहूर्त, पूजा विधि और शास्त्रीय वैदिक मार्गदर्शन। काशी पराशरी परंपरा में प्रशिक्षित।",
    keywords: [
      "पंडित",
      "पंडित जी",
      "ऑनलाइन पंडित",
      "AI पंडित",
      "पूजा के लिए पंडित",
      "दोष निवारण",
      "शुभ मुहूर्त",
    ],
    ogTitle: "AI पंडित जी — निःशुल्क दोष निवारण + मुहूर्त | Ishvaram",
    ogDescription:
      "AI पंडित जी से दोष निवारण, शुभ मुहूर्त और शास्त्रीय वैदिक मार्गदर्शन लें। निःशुल्क।",
  },
  "talk-to-astrologer": {
    title: "ज्योतिषी से मुफ्त बात करें | AI ज्योतिषी, कोई प्रति-मिनट शुल्क नहीं | Ishvaram",
    description:
      "ज्योतिषी से मुफ्त बात करें — Ishvaram का AI ज्योतिषी आपकी कुंडली पढ़कर दोष, दशा, करियर, विवाह और उपाय के सवालों का जवाब बिना प्रति-मिनट मीटर देता है। 24/7 उपलब्ध।",
    keywords: [
      "ज्योतिषी से बात करें",
      "मुफ्त ज्योतिषी",
      "ऑनलाइन ज्योतिषी",
      "talk to astrologer hindi",
      "jyotishi se baat",
      "free jyotish",
    ],
    ogTitle: "ज्योतिषी से मुफ्त बात करें — AI ज्योतिषी 24/7 | Ishvaram",
    ogDescription:
      "ज्योतिषी से मुफ्त बात करें — कुंडली, दोष, दशा, उपाय। कोई प्रति-मिनट शुल्क नहीं। 24/7 उपलब्ध।",
  },
  "chat-with-astrologer": {
    title: "ज्योतिषी से मुफ्त ऑनलाइन चैट | तुरंत AI ज्योतिषी | Ishvaram",
    description:
      "ज्योतिषी से मुफ्त ऑनलाइन चैट करें — Ishvaram का AI ज्योतिषी कुंडली, दोष, दशा और उपाय के सवाल तुरंत हल करता है, बिना प्रति-मिनट मीटर और बिना कतार। 24/7 उपलब्ध।",
    keywords: [
      "ज्योतिषी से चैट",
      "ऑनलाइन ज्योतिष चैट",
      "मुफ्त ज्योतिष चैट",
      "chat with astrologer hindi",
      "jyotishi se chat",
      "free astrology chat hindi",
    ],
    ogTitle: "ज्योतिषी से मुफ्त ऑनलाइन चैट — तुरंत | Ishvaram",
    ogDescription:
      "ज्योतिषी से मुफ्त ऑनलाइन चैट — तुरंत कुंडली, दोष, दशा, उपाय। कोई मीटर नहीं, कोई कतार नहीं।",
  },
  "astrologer-for-marriage-problem": {
    title: "शादी की समस्या के लिए ज्योतिषी | मुफ्त AI ज्योतिषी 7th House पढ़ता है | Ishvaram",
    description:
      "शादी की समस्या पर ज्योतिषी से मुफ्त बात करें। AI ज्योतिषी आपका 7th house, शुक्र और मंगल दोष पढ़ता है, ग्रह कारण बताता है और उपाय देता है — कोई प्रति-मिनट शुल्क नहीं।",
    keywords: [
      "शादी के लिए ज्योतिष",
      "विवाह समस्या ज्योतिष",
      "विवाह में देरी ज्योतिष",
      "मंगल दोष शादी",
      "shaadi ke liye jyotish",
      "marriage problem astrology hindi",
    ],
    ogTitle: "शादी की समस्या के लिए ज्योतिषी — मुफ्त 7th House पठन | Ishvaram",
    ogDescription:
      "मुफ्त AI ज्योतिषी शादी की समस्या के पीछे 7th house, शुक्र और मंगल दोष पढ़ता है, उपाय के साथ।",
  },
  "career-astrology-consultation": {
    title: "करियर के लिए ज्योतिष परामर्श मुफ्त | AI ज्योतिषी 10th House पढ़ता है | Ishvaram",
    description:
      "करियर के लिए मुफ्त ज्योतिष परामर्श — AI ज्योतिषी आपका 10th house, D10, सक्रिय दशा और शनि/गुरु गोचर पढ़कर बताता है कि करियर वृद्धि में क्या रुकावट है और उपाय। कोई प्रति-मिनट शुल्क नहीं।",
    keywords: [
      "करियर के लिए ज्योतिष",
      "करियर ज्योतिष परामर्श",
      "नौकरी ज्योतिष",
      "करियर भविष्यवाणी ज्योतिष",
      "career ke liye jyotish",
      "career astrology hindi",
    ],
    ogTitle: "करियर के लिए ज्योतिष परामर्श मुफ्त — 10th House पठन | Ishvaram",
    ogDescription:
      "मुफ्त करियर परामर्श — AI ज्योतिषी आपका 10th house, दशा और गोचर पढ़ता है, करियर उपाय के साथ।",
  },
  "muft-jyotish-chat": {
    title: "मुफ्त ज्योतिष चैट ऑनलाइन | कोई प्रति-मिनट शुल्क नहीं, 24/7 | Ishvaram",
    description:
      "AI ज्योतिषी से मुफ्त ज्योतिष चैट ऑनलाइन करें — कोई प्रति-मिनट शुल्क नहीं, कोई कतार नहीं। कुंडली, दोष, दशा, विवाह, करियर और उपाय तुरंत पूछें।",
    keywords: [
      "मुफ्त ज्योतिष चैट",
      "ऑनलाइन ज्योतिष चैट",
      "फ्री कुंडली चैट",
      "free astrology chat hindi",
      "muft jyotish chat",
      "ai jyotish chat hindi",
    ],
    ogTitle: "मुफ्त ज्योतिष चैट ऑनलाइन — कोई प्रति-मिनट शुल्क नहीं | Ishvaram",
    ogDescription:
      "AI ज्योतिषी से मुफ्त चैट — कुंडली, दोष, उपाय, राशिफल। कोई प्रति-मिनट शुल्क नहीं। 24/7 उपलब्ध।",
  },
  "career-report": {
    title: "करियर रिपोर्ट | वैदिक 10th House करियर रिपोर्ट | Ishvaram",
    description:
      "व्यक्तिगत वैदिक करियर रिपोर्ट — 10th house, D10/दशमांश, शनि, गुरु, दशा समय, धन योग और करियर उपाय। मेहनत के बावजूद करियर क्यों रुका है, यह आपकी कुंडली बताती है।",
    keywords: [
      "करियर रिपोर्ट",
      "करियर कुंडली रिपोर्ट",
      "करियर ज्योतिष रिपोर्ट",
      "career report hindi",
      "career kundali report",
      "नौकरी ज्योतिष रिपोर्ट",
    ],
    ogTitle: "करियर रिपोर्ट — वैदिक 10th House पठन | Ishvaram",
    ogDescription:
      "व्यक्तिगत करियर रिपोर्ट — 10th house, D10, दशा समय, धन योग और करियर उपाय आपकी कुंडली के अनुसार।",
  },
  "marriage-report": {
    title: "विवाह रिपोर्ट | कुंडली मिलान + 7th House विवाह रिपोर्ट | Ishvaram",
    description:
      "परिवार के साथ साझा करने योग्य विवाह रिपोर्ट — कुंडली मिलान, 7th house, मंगल दोष, D9/नवांश, दशा समय और व्यावहारिक उपाय। केवल गुण मिलान स्कोर से आगे का सच।",
    keywords: [
      "विवाह रिपोर्ट",
      "शादी रिपोर्ट",
      "कुंडली मिलान रिपोर्ट",
      "marriage report hindi",
      "vivah report",
      "मंगल दोष रिपोर्ट",
    ],
    ogTitle: "विवाह रिपोर्ट — कुंडली मिलान + 7th House पठन | Ishvaram",
    ogDescription:
      "विवाह रिपोर्ट — 36-गुण मिलान, मंगल दोष, D9/नवांश, दशा समय और उपाय परिवार के साथ साझा करने योग्य।",
  },
  "dosha-report": {
    title: "दोष रिपोर्ट | मंगल, काल सर्प, पितृ दोष जांच + उपाय | Ishvaram",
    description:
      "कुंडली-आधारित दोष रिपोर्ट — मंगल, काल सर्प, पितृ, शनि दोष की गंभीरता, रद्दीकरण और सुरक्षित उपाय। कोई भी कठोर उपाय करने से पहले अपनी कुंडली में सच जांचें।",
    keywords: [
      "दोष रिपोर्ट",
      "दोष जांच रिपोर्ट",
      "मंगल दोष रिपोर्ट",
      "dosha report hindi",
      "dosh report",
      "काल सर्प दोष रिपोर्ट",
    ],
    ogTitle: "दोष रिपोर्ट — गंभीरता, रद्दीकरण + सुरक्षित उपाय | Ishvaram",
    ogDescription:
      "दोष रिपोर्ट — मंगल, काल सर्प, पितृ, शनि दोष की गंभीरता और सुरक्षित उपाय आपकी कुंडली के अनुसार।",
  },
  "dosha-remedy-plan": {
    title: "दोष निवारण उपाय योजना | सुरक्षित उपाय क्रम रिपोर्ट | Ishvaram",
    description:
      "कुंडली-आधारित दोष निवारण उपाय योजना — कौन-सा दोष सक्रिय है, उसकी गंभीरता, और मंत्र, दान, व्रत, शांति का सुरक्षित उपाय क्रम। सामान्य उपाय सूची नहीं, आपकी कुंडली का उपाय।",
    keywords: [
      "दोष निवारण उपाय",
      "दोष उपाय योजना",
      "दोष निवारण रिपोर्ट",
      "dosha remedy plan hindi",
      "dosh nivaran upay",
      "उपाय योजना ज्योतिष",
    ],
    ogTitle: "दोष निवारण उपाय योजना — सुरक्षित उपाय क्रम | Ishvaram",
    ogDescription:
      "दोष निवारण उपाय योजना — सक्रिय दोष, गंभीरता और मंत्र/दान/व्रत/शांति का सुरक्षित उपाय क्रम।",
  },
  panchang: {
    // Rule 76. 246,408 impressions / 1,002 clicks at position 9.0 — the single
    // largest recoverable block on the site (+5,150 clicks/28d). Two causes:
    // (1) every top query is ROMAN, not Devanagari — "today panchang" 62,841
    // impr, "panchang today" 53,547, "today's panchang" 33,366, "todays
    // panchang" 15,949 — and the title showed a searcher none of the letters
    // they typed; (2) Google answers a generic panchang inside the SERP, so the
    // snippet has to promise what it cannot inline: the reading for YOUR city.
    // Title opens in Hinglish (rule 21's verified Roman-noun pattern) and keeps
    // the Devanagari a Hindi seeker scans for.
    title: "Aaj Ka Panchang: आज की तिथि, शुभ मुहूर्त और राहु काल",
    description:
      "आज का पंचांग आपके शहर के अनुसार — सूर्योदय, तिथि, नक्षत्र, योग, करण और राहु काल का सही समय, वैदिक गणना से। निःशुल्क।",
    keywords: [
      "पंचांग",
      "आज का पंचांग",
      "हिंदू पंचांग",
      "तिथि आज",
      "नक्षत्र आज",
      "panchang hindi",
      "aaj ka panchang",
    ],
    ogTitle: "आज का पंचांग | हिंदू पंचांग | Ishvaram",
    ogDescription:
      "आज का पंचांग — तिथि, नक्षत्र, योग, करण और ग्रह स्थिति। सटीक वैदिक गणना, निःशुल्क।",
  },
  "tithi-today": {
    title: "आज की तिथि | आज कौन सी तिथि है | हिंदू पंचांग | Ishvaram",
    description:
      "आज की तिथि हिंदी में — पक्ष, तिथि का नाम, प्रकार और महत्व। सभी 30 चंद्र तिथियों की सटीक जानकारी, व्रत, पूजा और शुभ मुहूर्त के लिए वैदिक मार्गदर्शन।",
    keywords: [
      "आज की तिथि",
      "आज कौन सी तिथि है",
      "तिथि आज",
      "आज का तिथि",
      "हिंदू तिथि",
      "tithi today",
      "aaj ki tithi",
    ],
    ogTitle: "आज की तिथि | आज कौन सी तिथि है | Ishvaram",
    ogDescription:
      "आज की तिथि, पक्ष और महत्व — व्रत, पूजा और शुभ मुहूर्त के लिए सटीक वैदिक गणना, निःशुल्क।",
  },
  rashifal: {
    title: "आज का राशिफल | दैनिक राशिफल | राशिफल हिंदी में | Ishvaram",
    description:
      "आज का राशिफल हिंदी में पढ़ें। सभी 12 राशियों का दैनिक, साप्ताहिक और मासिक राशिफल। AI-आधारित भविष्यवाणी वास्तविक ग्रह गोचर पर आधारित।",
    keywords: [
      "राशिफल",
      "आज का राशिफल",
      "दैनिक राशिफल",
      "राशिफल हिंदी",
      "aaj ka rashifal",
      "rashifal hindi",
    ],
    ogTitle: "आज का राशिफल | दैनिक राशिफल हिंदी में | Ishvaram",
    ogDescription:
      "सभी 12 राशियों का निःशुल्क दैनिक राशिफल। AI-आधारित भविष्यवाणी वास्तविक ग्रह गोचर पर आधारित।",
  },
  "free-kundali": {
    title: "फ्री कुंडली ऑनलाइन — जन्म तिथि से हिंदी जन्म कुंडली | Ishvaram",
    description:
      "जन्म तिथि, जन्म समय और जन्म स्थान से फ्री कुंडली ऑनलाइन बनाएं। लग्न, राशि, नक्षत्र, दोष, दशा, 12 भाव और AI ज्योतिष फल हिंदी में देखें।",
    keywords: [
      "कुंडली",
      "जन्म कुंडली",
      "फ्री कुंडली",
      "कुंडली बनाएं",
      "free kundali hindi",
      "janam kundali hindi",
    ],
    ogTitle: "फ्री कुंडली ऑनलाइन | हिंदी जन्म कुंडली | Ishvaram",
    ogDescription:
      "जन्म तिथि, समय और स्थान से फ्री कुंडली ऑनलाइन बनाएं — लग्न, राशि, नक्षत्र, दोष, दशा और AI फल।",
  },
  "kundli-matching": {
    title: "निःशुल्क कुंडली मिलान — 36 गुण मिलान, मांगलिक दोष जाँच | Ishvaram",
    description:
      "निःशुल्क कुंडली मिलान (गुण मिलान) करें। अष्टकूट 36 गुण विश्लेषण, मांगलिक दोष जाँच और सभी 8 कूटों का विस्तृत विवरण। विवाह अनुकूलता जानें।",
    keywords: [
      "कुंडली मिलान",
      "गुण मिलान",
      "kundali milaan",
      "विवाह अनुकूलता",
      "36 गुण",
      "अष्टकूट",
    ],
    ogTitle: "कुंडली मिलान | गुण मिलान | Ishvaram",
    ogDescription: "निःशुल्क कुंडली मिलान — अष्टकूट 36 गुण + मांगलिक दोष जाँच।",
  },
  choghadiya: {
    title: "चौघड़िया आज | शुभ चौघड़िया समय | Ishvaram",
    description:
      "आज का चौघड़िया — सभी 8 चौघड़िया काल, शुभ और अशुभ समय। दिन और रात के चौघड़िया की पूरी जानकारी। सटीक वैदिक गणना, निःशुल्क।",
    keywords: ["चौघड़िया", "आज का चौघड़िया", "शुभ चौघड़िया", "choghadiya hindi", "choghadiya aaj"],
  },
  "rahu-kaal": {
    title: "राहु काल आज | Rahu Kaal Time | Ishvaram",
    description:
      "आज का राहु काल समय — सोमवार से रविवार तक राहु काल की सटीक जानकारी। राहु काल में शुभ कार्य न करें। निःशुल्क राहु काल कैलकुलेटर।",
    keywords: ["राहु काल", "आज का राहु काल", "rahu kaal hindi", "yamagandam", "gulika kaal"],
  },
  muhurat: {
    // Rule 76: 61 chars, so "| Ishvaram" truncated. This page's own queries are
    // overwhelmingly ROMAN, not Devanagari — "muhurat" 1,898 impr, "shubh
    // muhurat" 218, "muhrat" 213, "muharat" 131 vs "शुभ मूहर्त" 95 — so the
    // title leads in Hinglish (rule 21's verified Roman-noun pattern) and keeps
    // the Devanagari event names a Hindi seeker scans for.
    title: "Shubh Muhurat {year} — विवाह, गृह प्रवेश, वाहन शुभ तिथि",
    description:
      "विवाह, गृह प्रवेश, वाहन, व्यापार, मुंडन के लिए शुभ मुहूर्त {year}। पंचांग आधारित नक्षत्र और तिथि के अनुसार शुभ तिथियाँ।",
    keywords: [
      "शुभ मुहूर्त {year}",
      "विवाह मुहूर्त {year}",
      "गृह प्रवेश मुहूर्त {year}",
      "muhurat hindi",
      "shubh muhurat",
    ],
  },
  numerology: {
    title: "अंक ज्योतिष कैलकुलेटर | मूलांक भाग्यांक नामांक | निःशुल्क | Ishvaram",
    description:
      "निःशुल्क अंक ज्योतिष कैलकुलेटर। अपना मूलांक, भाग्यांक और नामांक जानें। वैदिक कैल्डियन अंक शास्त्र पर आधारित।",
    keywords: ["अंक ज्योतिष", "मूलांक", "भाग्यांक", "numerology hindi", "ank jyotish"],
  },
  "name-numerology": {
    title: "नाम अंकज्योतिष | अपने नाम का अंक जानें | Ishvaram",
    description:
      "नाम अंकज्योतिष — अपने नाम के अंक का अर्थ जानें। नाम की संख्या और उसका प्रभाव। वैदिक अंकशास्त्र पर आधारित।",
    keywords: ["नाम अंकज्योतिष", "name numerology hindi", "नाम अंक", "naam numerology"],
  },
  "mulank-calculator": {
    // Dominant query (GSC 28d to 2026-07-20) is the how-to, not the noun:
    // "mulank kaise nikale" 3,231 impr at pos 9.1, vs "mera mulank kya hai"
    // 188. Title now leads with that and fits the 60-char SERP budget (was 67,
    // so "निःशुल्क" was truncated away on mobile anyway). The description keeps
    // its rule-22 pain-question hook — that is governed positioning, not debt.
    title: "मूलांक कैसे निकालें — निःशुल्क मूलांक कैलकुलेटर | Ishvaram",
    description:
      "आपके जीवन में एक ही पैटर्न बार-बार क्यों आता है? आपका मूलांक — जन्म तारीख का मूल अंक — इसका कारण है। निःशुल्क मूलांक कैलकुलेटर: मूलांक (1-9), स्वामी ग्रह और उपाय जानें।",
    keywords: [
      "मूलांक कैलकुलेटर",
      "mulank calculator hindi",
      "मूलांक कैसे निकालें",
      "मूलांक",
      "ank jyotish mulank",
    ],
  },
  "bhagyank-calculator": {
    title: "भाग्यांक कैलकुलेटर | जन्म तिथि से भाग्यांक जानें | निःशुल्क | Ishvaram",
    description:
      "आपकी मेहनत उस जीवन में क्यों नहीं बदलती जो आपने सोचा था? आपका भाग्यांक — पूरी जन्म तिथि से बना अंक — जीवन पथ बताता है। निःशुल्क भाग्यांक कैलकुलेटर: भाग्यांक (1-9), स्वामी ग्रह और उपाय जानें।",
    keywords: [
      "भाग्यांक कैलकुलेटर",
      "bhagyank calculator hindi",
      "भाग्यांक कैसे निकालें",
      "भाग्यांक",
      "mulank bhagyank hindi",
    ],
  },
  "baby-names": {
    title: "नक्षत्र के अनुसार बच्चे का नाम | राशि अनुसार नाम | Ishvaram",
    description:
      "नक्षत्र और अंक ज्योतिष के अनुसार बच्चे का सही नाम खोजें। 1500+ प्रामाणिक संस्कृत नाम — हिंदी अर्थ, पाद और अंक स्कोर।",
    keywords: [
      "बच्चे का नाम",
      "नक्षत्र अनुसार नाम",
      "baby names hindi",
      "nakshatra naam",
      "hindu baby names hindi",
    ],
  },
  "ascendant-calculator": {
    title: "लग्न कैलकुलेटर | जन्म समय से लग्न जानें | Ishvaram",
    description:
      "लग्न कैलकुलेटर — जन्म समय और स्थान से अपना लग्न (Ascendant) जानें। 12 लग्नों की विस्तृत जानकारी। निःशुल्क।",
    keywords: ["लग्न", "लग्न कैलकुलेटर", "lagna calculator hindi", "ascendant hindi"],
  },
  "nakshatra-calculator": {
    title: "नक्षत्र कैलकुलेटर | जन्म नक्षत्र जानें | निःशुल्क | Ishvaram",
    description:
      "अपना जन्म नक्षत्र (Birth Star) निःशुल्क जानें। नक्षत्र, पाद, स्वामी ग्रह, देवता और नाम अक्षर तुरंत प्राप्त करें।",
    keywords: ["नक्षत्र", "जन्म नक्षत्र", "nakshatra hindi", "nakshatra calculator hindi"],
  },
  rashi: {
    title: "12 राशियां — वैदिक ज्योतिष में सभी राशियों की जानकारी | Ishvaram",
    description:
      "वैदिक ज्योतिष की सभी 12 राशियों की विशेषताएं, स्वामी ग्रह, तत्व, व्यक्तित्व और अनुकूलता। अपनी चंद्र राशि जानें।",
    keywords: [
      "12 राशियां",
      "राशि",
      "rashi hindi",
      "rashi visheshata",
      "chandra rashi",
      "vedic astrology hindi",
    ],
  },
  "rashi-calculator": {
    title: "राशि कैलकुलेटर | जन्म तिथि से राशि जानें | निःशुल्क | Ishvaram",
    description:
      "जन्म तिथि से अपनी राशि (चंद्र राशि) तुरंत जानें। 100% निःशुल्क और सटीक वैदिक राशि कैलकुलेटर — स्वामी ग्रह, तत्व और अनुकूलता।",
    keywords: ["राशि कैलकुलेटर", "राशि", "rashi calculator hindi", "janm rashi", "chandra rashi"],
  },
  "mangal-dosha-calculator": {
    title: "मांगलिक दोष कैलकुलेटर — क्या आप मांगलिक हैं? जन्म तिथि से निःशुल्क जाँच | Ishvaram",
    description:
      "विवाह में बार-बार अड़चन क्यों आती है? मंगल जब विशेष भावों में होता है तो मांगलिक दोष बनता है। तीव्रता, दोष भंग की शर्तें और शास्त्रीय उपाय — निःशुल्क।",
    keywords: ["मांगलिक दोष", "मंगल दोष", "mangal dosha hindi", "mangalik check hindi"],
  },
  "dasha-calculator": {
    title: "दशा कैलकुलेटर {year} | अभी चल रही महादशा जानें | निःशुल्क | Ishvaram",
    description:
      "जन्म तिथि से जानें अभी कौन सी महादशा और अंतर्दशा चल रही है। निःशुल्क विमशोत्तरी दशा कैलकुलेटर — 9 ग्रहों की पूरी दशा अवधि।",
    keywords: [
      "दशा कैलकुलेटर",
      "महादशा कैलकुलेटर",
      "अंतर्दशा",
      "dasha calculator hindi",
      "vimshottari dasha hindi",
      "mahadasha {year}",
    ],
  },
  "kaal-sarp-dosha": {
    title:
      "काल सर्प दोष — मेहनत करने के बाद भी सफलता क्यों नहीं मिलती? 12 प्रकार और उपाय | Ishvaram",
    description:
      "जब सभी ग्रह राहु-केतु अक्ष में फँस जाते हैं, तो काल सर्प दोष एक अदृश्य छत बनाता है। 12 प्रकार — अनंत से शेषनाग तक — और त्र्यंबकेश्वर पूजा, रुद्राभिषेक उपाय। कुंडली में निःशुल्क जाँचें।",
    keywords: [
      "काल सर्प दोष",
      "kaal sarp dosh hindi",
      "kaal sarp dosha ke upay",
      "काल सर्प दोष के 12 प्रकार",
      "kaal sarp dosh check",
    ],
  },
  "pitra-dosha": {
    title: "पितृ दोष — परिवार में बाधाएं बार-बार क्यों लौटती हैं? लक्षण, पहचान और उपाय | Ishvaram",
    description:
      "पितृ दोष पूर्वजों के अनसुलझे कर्म का प्रभाव है — यह संतान, भाग्य और पारिवारिक शांति को बाधित करता है। 6 शास्त्रीय संकेत, जीवन के लक्षण और तर्पण-श्राद्ध उपाय। कुंडली में निःशुल्क जाँचें।",
    keywords: [
      "पितृ दोष",
      "pitra dosh hindi",
      "pitra dosh ke upay",
      "pitra dosh symptoms hindi",
      "पितृ दोष उपाय",
    ],
  },
  "gun-milan": {
    title: "गुण मिलान कैलकुलेटर — फ्री कुंडली मिलान, 36 अष्टकूट | Ishvaram",
    description:
      "फ्री गुण मिलान कैलकुलेटर — पूरा 36 अष्टकूट कुंडली मिलान, मांगलिक दोष व नाड़ी दोष जाँच और विवाह अनुकूलता का स्पष्ट निर्णय। वर-वधू का जन्म विवरण दें और स्कोर तुरंत पाएं।",
    keywords: ["गुण मिलान", "kundali gun milan", "36 gun", "ashtakoot hindi"],
  },
  "sade-sati": {
    title: "साढ़े साती — अभी जीवन इतना भारी क्यों लग रहा है? कारण और उपाय | Ishvaram",
    description:
      "शनि जब आपकी चंद्र राशि पर साढ़े सात वर्ष गोचर करता है, तो यही साढ़े साती है। अपना चरण जानें (उदय, मध्य, अस्त), कब समाप्त होगी और शास्त्रीय उपाय — निःशुल्क।",
    keywords: ["साढ़े साती", "sade sati hindi", "shani sade sati", "शनि साढ़े साती"],
  },
  transits: {
    title: "ग्रह गोचर {year} | शनि गोचर | गुरु गोचर | साढ़े साती | Ishvaram",
    description:
      "आज का ग्रह गोचर देखें — शनि, गुरु, राहु-केतु की वर्तमान स्थिति। निःशुल्क साढ़े साती जाँच, ढैय्या स्थिति और गोचर प्रभाव।",
    keywords: [
      "ग्रह गोचर",
      "shani gochar hindi",
      "guru gochar hindi",
      "rahu ketu gochar",
      "grah gochar {year}",
    ],
  },
  remedies: {
    title: "दोष उपाय | कुंडली उपाय | ग्रह शांति | Ishvaram",
    description:
      "अपनी जन्म कुंडली के दोषों के व्यक्तिगत उपाय पाएँ। मांगलिक दोष, काल सर्प दोष, शनि दोष और अन्य दोषों के शास्त्रीय उपाय।",
    keywords: [
      "दोष उपाय",
      "कुंडली उपाय",
      "grah shanti",
      "mangal dosha upay",
      "kundali remedies hindi",
    ],
  },
  upay: {
    title: "उपाय | दोष निवारण, ग्रह शांति और वैदिक उपाय | Ishvaram",
    description:
      "मांगलिक, शनि, राहु, केतु, काल सर्प और पितृ दोष के लिए वैदिक उपाय देखें। मंत्र, दान, व्रत और सिद्ध वस्तुओं से कुंडली के दोष संतुलित करें।",
    keywords: [
      "दोष उपाय",
      "कुंडली उपाय",
      "grah shanti",
      "mangal dosha upay",
      "kundali remedies hindi",
    ],
  },
  compatibility: {
    title: "राशि अनुकूलता | कुंडली मिलान सभी राशियाँ | Ishvaram",
    description:
      "सभी 144 राशि जोड़ों की वैदिक अनुकूलता जाँचें। प्रेम, विवाह और मित्रता के लिए राशि मिलान विश्लेषण।",
    keywords: [
      "राशि अनुकूलता",
      "rashi compatibility hindi",
      "rashi milaan",
      "kundali milaan sab rashi",
    ],
  },
  nakshatra: {
    title: "27 नक्षत्र | जन्म नक्षत्र गाइड | अपना नक्षत्र जानें | Ishvaram",
    description:
      "वैदिक ज्योतिष में सभी 27 नक्षत्रों की जानकारी। जन्म नक्षत्र, व्यक्तित्व, करियर, विवाह अनुकूलता और वैदिक उपाय — निःशुल्क।",
    keywords: [
      "नक्षत्र",
      "27 नक्षत्र",
      "जन्म नक्षत्र",
      "nakshatra hindi",
      "nakshatra meaning hindi",
      "nakshatra calculator hindi",
    ],
  },
  graha: {
    title: "नवग्रह — 9 ग्रहों की जानकारी हिंदी में | वैदिक ज्योतिष | Ishvaram",
    description:
      "वैदिक ज्योतिष के नवग्रह — सूर्य, चंद्र, मंगल, बुध, गुरु, शुक्र, शनि, राहु और केतु। प्रत्येक ग्रह का स्वभाव, दशा काल, रत्न और शास्त्रीय उपाय।",
    keywords: [
      "नवग्रह",
      "9 ग्रह",
      "navgraha hindi",
      "grah hindi",
      "vedic astrology grah",
      "graha hindi",
    ],
    ogTitle: "नवग्रह — वैदिक ज्योतिष के 9 ग्रह | Ishvaram",
    ogDescription: "सूर्य से केतु तक — सभी 9 नवग्रहों का स्वभाव, रत्न, दशा और उपाय हिंदी में।",
  },
  "aaj-ka-rashifal": {
    title: "आज का राशिफल: 12 राशियों की सटीक ग्रह स्थिति और कुंडली विवरण",
    description:
      "प्रत्येक राशि के लिए आज का राशिफल जानें। सूर्य, चंद्र, शनि जैसे ग्रहों की सटीक स्थिति और कुंडली विश्लेषण। 100% मुफ्त और बिना रजिस्ट्रेशन के।",
    ogTitle: "आज का राशिफल: 12 राशियों की सटीक ग्रह स्थिति और कुंडली विवरण",
    ogDescription:
      "प्रत्येक राशि के लिए आज का राशिफल जानें। सूर्य, चंद्र, शनि जैसे ग्रहों की सटीक स्थिति और कुंडली विश्लेषण। 100% मुफ्त और बिना रजिस्ट्रेशन के।",
  },
  "bhai-dooj-2026": {
    title: "भाई दूज 2026: भाइयों की शुभ तिथि और ज्योतिषीय महत्व",
    description:
      "11 नवंबर 2026 को भाई दूज: भाइयों की रक्षा, सुख-समृद्धि के लिए पूजा विधि और ग्रह प्रभाव।",
    ogTitle: "भाई दूज 2026: भाइयों की शुभ तिथि और ज्योतिषीय महत्व",
    ogDescription:
      "11 नवंबर 2026 को भाई दूज: भाइयों की रक्षा, सुख-समृद्धि के लिए पूजा विधि और ग्रह प्रभाव।",
  },
  "chhath-puja-2026": {
    title: "छठ पूजा 2026: तिथि, समय, पूजा विधि और महत्व",
    description:
      "15 नवंबर 2026 को छठ पूजा: सूर्य देव की पूजा, व्रत, स्नान और आरती की विधि। जानें तिथि, समय और पूजा का महत्व।",
    ogTitle: "छठ पूजा 2026: तिथि, समय, पूजा विधि और महत्व",
    ogDescription:
      "15 नवंबर 2026 को छठ पूजा: सूर्य देव की पूजा, व्रत, स्नान और आरती की विधि। जानें तिथि, समय और पूजा का महत्व।",
  },
  "dhanteras-2026": {
    title: "धनतेरस 2026: तिथि, शुभ मुहूर्त, पूजा विधि और महत्व",
    description:
      "7 नवंबर 2026 को धनतेरस की तिथि, पूजा विधि, शुभ समय और महत्व जानें। लक्ष्मी पूजन के लिए सटीक जानकारी",
    ogTitle: "धनतेरस 2026: तिथि, शुभ मुहूर्त, पूजा विधि और महत्व",
    ogDescription:
      "7 नवंबर 2026 को धनतेरस की तिथि, पूजा विधि, शुभ समय और महत्व जानें। लक्ष्मी पूजन के लिए सटीक जानकारी",
  },
  "diwali-2026": {
    title: "दिवाली 2026: कुंडली, मुहूर्त, पूजा विधि — लक्ष्मी जी की कृपा",
    description:
      "दिवाली 2026 की तिथि 9 नवंबर है। जानें कुंडली, शुभ मुहूर्त, और पूजा विधि। लाभ उठाएं इस पावन अवसर को!",
    ogTitle: "दिवाली 2026: कुंडली, मुहूर्त, पूजा विधि — लक्ष्मी जी की कृपा",
    ogDescription:
      "दिवाली 2026 की तिथि 9 नवंबर है। जानें कुंडली, शुभ मुहूर्त, और पूजा विधि। लाभ उठाएं इस पावन अवसर को!",
  },
  "dussehra-2026": {
    title: "दशहरा 2026: विजयादशमी की तिथि, पूजा विधि और महत्त्व",
    description:
      "21 सितंबर 2026 को मनाया जाने वाला दशहरा (विजयादशमी)। रावणदहन, दुर्गा पूजा और घर में शांति के उपाय जानें।",
    ogTitle: "दशहरा 2026: विजयादशमी की तिथि, पूजा विधि और महत्त्व",
    ogDescription:
      "21 सितंबर 2026 को मनाया जाने वाला दशहरा (विजयादशमी)। रावणदहन, दुर्गा पूजा और घर में शांति के उपाय जानें।",
  },
  "ganesh-chaturthi-2026": {
    title: "गणेश चतुर्थी 2026: कुंडली, राशि और उपाय | Ishvaram.com",
    description:
      "16 अगस्त 2026 को मनाए जाने वाली गणेश चतुर्थी का तिथि, समय, कुंडली विश्लेषण और शुभ उपाय जानें। पारिवारिक ज्योतिषी से सलाह।",
    ogTitle: "गणेश चतुर्थी 2026: कुंडली, राशि और उपाय | Ishvaram.com",
    ogDescription:
      "16 अगस्त 2026 को मनाए जाने वाली गणेश चतुर्थी का तिथि, समय, कुंडली विश्लेषण और शुभ उपाय जानें। पारिवारिक ज्योतिषी से सलाह।",
  },
  "karwa-chauth-2026": {
    title: "करवा चौथ 2026: पत्नी-पति के लिए शुभ व्रत उपाय",
    description:
      "29 अक्टूबर 2026 को करवा चौथ व्रत की तिथि, समय और महत्व। शुभ उपाय जानें और पारिवारिक सुख-समृद्धि पाएं।",
    ogTitle: "करवा चौथ 2026: पत्नी-पति के लिए शुभ व्रत उपाय",
    ogDescription:
      "29 अक्टूबर 2026 को करवा चौथ व्रत की तिथि, समय और महत्व। शुभ उपाय जानें और पारिवारिक सुख-समृद्धि पाएं।",
  },
  "navratri-2026": {
    title: "शारदीय नवरात्रि 2026: तिथि, व्रत, पूजा विधि और महत्व",
    description:
      "12 सितंबर 2026 को मनाया जाने वाला शारदीय नवरात्रि का पवित्र पर्व। जानें तिथि, व्रत, पूजा और राशिफल के साथ इसके धार्मिक महत्व को।",
    ogTitle: "शारदीय नवरात्रि 2026: तिथि, व्रत, पूजा विधि और महत्व",
    ogDescription:
      "12 सितंबर 2026 को मनाया जाने वाला शारदीय नवरात्रि का पवित्र पर्व। जानें तिथि, व्रत, पूजा और राशिफल के साथ इसके धार्मिक महत्व को।",
  },
  "raksha-bandhan-2026": {
    title: "रक्षाबंधन 2026: भाई-बहन का पवित्र बंधन और शुभ मुहूर्त",
    description:
      "रक्षाबंधन 29 जुलाई 2026 को मनाया जाएगा। जानें तिथि, शुभ समय, रीति-रिवाज और भाई-बहन के बीच प्यार को मजबूत करने के उपाय।",
    ogTitle: "रक्षाबंधन 2026: भाई-बहन का पवित्र बंधन और शुभ मुहूर्त",
    ogDescription:
      "रक्षाबंधन 29 जुलाई 2026 को मनाया जाएगा। जानें तिथि, शुभ समय, रीति-रिवाज और भाई-बहन के बीच प्यार को मजबूत करने के उपाय।",
  },

  "holi-2027": {
    title: "होली 2027: कुंडली, राशि और शुभ उपाय | वैदिक ज्योतिष",
    description:
      "होली 4 मार्च 2027 को मनाई जाएगी। जानें अपने राशि के लिए शुभ मुहूर्त, दोष निवारण और विशेष उपाय। वैदिक ज्योतिष के अनुसार होली की तिथि और महत्व।",
    ogTitle: "होली 2027: कुंडली, राशि और शुभ उपाय | वैदिक ज्योतिष",
    ogDescription:
      "होली 4 मार्च 2027 को मनाई जाएगी। जानें अपने राशि के लिए शुभ मुहूर्त, दोष निवारण और विशेष उपाय। वैदिक ज्योतिष के अनुसार होली की तिथि और महत्व।",
  },
  "janmashtami-2026": {
    title: "2026 कृष्ण जन्माष्टमी: कुंडली, राशि, उपाय और पंचांग विवरण",
    description:
      "6 अगस्त 2026 को मनाए जाने वाली कृष्ण जन्माष्टमी की तिथि, मुहूर्त, कुंडली विश्लेषण और विशेष उपाय। जानें राशि अनुसार प्रभाव।",
    ogTitle: "2026 कृष्ण जन्माष्टमी: कुंडली, राशि, उपाय और पंचांग विवरण",
    ogDescription:
      "6 अगस्त 2026 को मनाए जाने वाली कृष्ण जन्माष्टमी की तिथि, मुहूर्त, कुंडली विश्लेषण और विशेष उपाय। जानें राशि अनुसार प्रभाव।",
  },

  "govardhan-puja-2026": {
    title: "गोवर्धन पूजा (अन्नकूट) 2026: तिथि, पूजा विधि और मुहूर्त",
    description:
      "गोवर्धन पूजा (अन्नकूट) 2026 की तारीख, तिथि, पूजा विधि, व्रत नियम और शुभ मुहूर्त जानें।",
    ogTitle: "गोवर्धन पूजा (अन्नकूट) 2026: तिथि, पूजा विधि और मुहूर्त",
    ogDescription:
      "गोवर्धन पूजा (अन्नकूट) 2026 की तारीख, तिथि, पूजा विधि, व्रत नियम और शुभ मुहूर्त जानें।",
  },
  mantras: {
    title: "ग्रह मंत्र उपाय — सभी 9 नवग्रहों के वैदिक मंत्र | इश्वरम",
    description:
      "सभी 9 ग्रहों के वैदिक मंत्र उपाय — सूर्य, चन्द्र, मंगल, बुध, गुरु, शुक्र, शनि, राहु, केतु। बीज मंत्र, वैदिक मंत्र, जाप विधि और शास्त्रोक्त उपाय।",
    keywords: [
      "ग्रह मंत्र",
      "वैदिक मंत्र",
      "शनि मंत्र",
      "राहु मंत्र",
      "मंत्र उपाय",
      "बीज मंत्र",
      "नवग्रह मंत्र",
    ],
    ogTitle: "सभी 9 नवग्रहों के मंत्र उपाय | इश्वरम",
    ogDescription:
      "बीज मंत्र, वैदिक मंत्र और जाप विधि — सभी 9 ग्रहों के लिए। शनि, राहु, मंगल और अधिक।",
  },
  "mantras/surya": {
    title: "सूर्य मंत्र — बीज मंत्र, जाप विधि और उपाय | इश्वरम",
    description:
      "सूर्य के पूर्ण मंत्र उपाय — ॐ ह्रां ह्रीं ह्रौं सः सूर्याय नमः बीज मंत्र, वैदिक मंत्र, गायत्री मंत्र और जाप विधि। कमजोर सूर्य के लिए उपाय।",
    keywords: ["सूर्य मंत्र", "सूर्य बीज मंत्र", "सूर्य उपाय"],
  },
  "mantras/chandra": {
    title: "चन्द्र मंत्र — बीज मंत्र, जाप विधि और उपाय | इश्वरम",
    description:
      "चन्द्र के पूर्ण मंत्र उपाय — ॐ श्रां श्रीं श्रौं सः चन्द्रमसे नमः बीज मंत्र और जाप विधि। मन की शांति और कमजोर चन्द्र के लिए उपाय।",
    keywords: ["चन्द्र मंत्र", "चन्द्र बीज मंत्र", "मन शांति मंत्र"],
  },
  "mantras/mangal": {
    title: "मंगल मंत्र — बीज मंत्र, मंगल दोष उपाय | इश्वरम",
    description:
      "मंगल के पूर्ण मंत्र उपाय — ॐ क्रां क्रीं क्रौं सः भौमाय नमः बीज मंत्र और जाप विधि। मंगल दोष निवारण और क्रोध शांति के लिए मंत्र।",
    keywords: ["मंगल मंत्र", "मंगल दोष उपाय मंत्र", "मंगल शांति मंत्र"],
  },
  "mantras/budh": {
    title: "बुध मंत्र — बीज मंत्र, जाप विधि और उपाय | इश्वरम",
    description:
      "बुध के पूर्ण मंत्र उपाय — ॐ ब्रां ब्रीं ब्रौं सः बुधाय नमः बीज मंत्र और जाप विधि। बुद्धि और संचार के लिए बुध मंत्र उपाय।",
    keywords: ["बुध मंत्र", "बुध बीज मंत्र", "बुद्धि मंत्र"],
  },
  "mantras/guru": {
    title: "गुरु मंत्र — बृहस्पति बीज मंत्र, जाप विधि और उपाय | इश्वरम",
    description:
      "गुरु (बृहस्पति) के पूर्ण मंत्र उपाय — ॐ ग्रां ग्रीं ग्रौं सः गुरवे नमः बीज मंत्र और जाप विधि। ज्ञान, भाग्य और गुरु चांडाल योग के उपाय।",
    keywords: ["गुरु मंत्र", "बृहस्पति मंत्र", "भाग्य मंत्र"],
  },
  "mantras/shukra": {
    title: "शुक्र मंत्र — बीज मंत्र, जाप विधि और उपाय | इश्वरम",
    description:
      "शुक्र के पूर्ण मंत्र उपाय — ॐ द्रां द्रीं द्रौं सः शुक्राय नमः बीज मंत्र और जाप विधि। प्रेम, विवाह और कमजोर शुक्र के लिए उपाय।",
    keywords: ["शुक्र मंत्र", "शुक्र बीज मंत्र", "विवाह उपाय मंत्र"],
  },
  "mantras/shani": {
    title: "शनि मंत्र — बीज मंत्र, साढ़े साती उपाय | इश्वरम",
    description:
      "शनि के पूर्ण मंत्र उपाय — ॐ प्रां प्रीं प्रौं सः शनैश्चराय नमः बीज मंत्र और जाप विधि। साढ़े साती, शनि महादशा और शनि दोष निवारण।",
    keywords: ["शनि मंत्र", "शनि बीज मंत्र", "साढ़े साती उपाय मंत्र"],
  },
  "mantras/rahu": {
    title: "राहु मंत्र — बीज मंत्र, काल सर्प दोष उपाय | इश्वरम",
    description:
      "राहु के पूर्ण मंत्र उपाय — ॐ भ्रां भ्रीं भ्रौं सः राहवे नमः बीज मंत्र और जाप विधि। राहु महादशा, काल सर्प दोष निवारण मंत्र।",
    keywords: ["राहु मंत्र", "राहु बीज मंत्र", "काल सर्प दोष उपाय मंत्र"],
  },
  "mantras/ketu": {
    title: "केतु मंत्र — बीज मंत्र, जाप विधि और उपाय | इश्वरम",
    description:
      "केतु के पूर्ण मंत्र उपाय — ॐ स्रां स्रीं स्रौं सः केतवे नमः बीज मंत्र और जाप विधि। केतु महादशा और काल सर्प दोष निवारण।",
    keywords: ["केतु मंत्र", "केतु बीज मंत्र", "केतु महादशा उपाय"],
  },
  ekadashi: {
    title: "एकादशी {year} — तिथि, व्रत नियम, पारण समय और पूजा विधि | इश्वरम",
    description:
      "एकादशी {year} और {nextyear} की तिथियाँ — एकादशी व्रत के नियम, पारण का समय, विष्णु पूजा विधि और उपाय। तिथि-गणना से, किसी निश्चित कैलेंडर का अनुमान नहीं।",
    keywords: [
      "एकादशी",
      "एकादशी {year}",
      "एकादशी व्रत",
      "एकादशी कब है",
      "एकादशी तिथि",
      "एकादशी पारण समय",
      "निर्जला एकादशी",
      "एकादशी व्रत विधि",
    ],
  },
  amavasya: {
    title: "अमावस्या {year} — तिथि, पितृ तर्पण, श्राद्ध और पूजा विधि | इश्वरम",
    description:
      "अमावस्या {year} और {nextyear} की तिथियाँ — अमावस्या का अर्थ, पितृ तर्पण और श्राद्ध विधि, महालया व मौनी अमावस्या, और पितृ दोष के उपाय। तिथि-गणना से, अनुमान नहीं।",
    keywords: [
      "अमावस्या",
      "अमावस्या {year}",
      "अमावस्या कब है",
      "अमावस्या तिथि",
      "पितृ तर्पण",
      "श्राद्ध अमावस्या",
      "महालया अमावस्या",
      "मौनी अमावस्या",
      "अमावस्या पूजा विधि",
    ],
  },
  purnima: {
    title: "पूर्णिमा {year} — तिथि, सत्यनारायण व्रत और पूजा विधि | इश्वरम",
    description:
      "पूर्णिमा {year} और {nextyear} की तिथियाँ — पूर्णिमा का अर्थ, सत्यनारायण व्रत के नियम और पूजा विधि, गुरु, शरद व कार्तिक पूर्णिमा, और अशांत चंद्रमा के उपाय। तिथि-गणना से, अनुमान नहीं।",
    keywords: [
      "पूर्णिमा",
      "पूर्णिमा {year}",
      "पूर्णिमा व्रत",
      "पूर्णिमा कब है",
      "पूर्णिमा तिथि",
      "सत्यनारायण व्रत",
      "शरद पूर्णिमा",
      "गुरु पूर्णिमा",
      "पूर्णिमा पूजा विधि",
    ],
  },
  pradosh: {
    title: "प्रदोष व्रत {year} — तिथि, त्रयोदशी, शिव पूजा विधि | इश्वरम",
    description:
      "प्रदोष व्रत {year} और {nextyear} की तिथियाँ — त्रयोदशी का अर्थ, सोम प्रदोष, भौम प्रदोष और शनि प्रदोष, शिव पूजा विधि और शनि दोष के उपाय। तिथि-गणना से, अनुमान नहीं।",
    keywords: [
      "प्रदोष व्रत",
      "प्रदोष व्रत {year}",
      "प्रदोष तिथि",
      "शनि प्रदोष",
      "सोम प्रदोष",
      "भौम प्रदोष",
      "त्रयोदशी व्रत",
      "प्रदोष पूजा विधि",
      "प्रदोष काल",
    ],
  },
  "sankashti-chaturthi": {
    title: "संकष्टी चतुर्थी {year} — तिथि, व्रत, चंद्रोदय समय और गणेश पूजा विधि | इश्वरम",
    description:
      "संकष्टी चतुर्थी {year} और {nextyear} की तिथियाँ — चतुर्थी व्रत और चंद्र दर्शन के नियम, गणेश पूजा विधि, अंगारकी चतुर्थी, और रुके हुए कार्य व बाधाओं के उपाय। तिथि-गणना से, अनुमान नहीं।",
    keywords: [
      "संकष्टी चतुर्थी",
      "संकष्टी चतुर्थी {year}",
      "संकष्टी चतुर्थी कब है",
      "संकष्टी व्रत",
      "अंगारकी चतुर्थी",
      "गणेश चतुर्थी व्रत",
      "चंद्रोदय समय",
      "संकष्टी पूजा विधि",
    ],
  },
  "masik-shivratri": {
    title: "मासिक शिवरात्रि {year} — तिथि, व्रत, रात्रि जागरण और शिव पूजा विधि | इश्वरम",
    description:
      "मासिक शिवरात्रि {year} और {nextyear} की तिथियाँ — चतुर्दशी व्रत और रात्रि जागरण के नियम, शिव पूजा विधि व अभिषेक, महाशिवरात्रि से अंतर, और शिव पूजा से शनि/मंगल के उपाय। तिथि-गणना से, अनुमान नहीं।",
    keywords: [
      "मासिक शिवरात्रि",
      "मासिक शिवरात्रि {year}",
      "मासिक शिवरात्रि कब है",
      "मासिक शिवरात्रि व्रत",
      "शिवरात्रि व्रत विधि",
      "शिव पूजा विधि",
      "महाशिवरात्रि",
      "महामृत्युंजय मंत्र",
    ],
  },
  sankranti: {
    title: "संक्रांति {year} — सभी 12 संक्रांति तिथियाँ, मकर संक्रांति और पूजा विधि | इश्वरम",
    description:
      "संक्रांति {year} और {nextyear} की 12 सौर संक्रांति तिथियाँ — मकर संक्रांति, उत्तरायण, स्नान-दान पुण्य काल विधि, और हर संक्रांति आपके लिए क्या मायने रखती है। तिथि सूर्य संक्रमण से गणना, अनुमान नहीं।",
    keywords: [
      "संक्रांति",
      "संक्रांति {year}",
      "संक्रांति कब है",
      "मकर संक्रांति",
      "मकर संक्रांति {year}",
      "उत्तरायण",
      "सूर्य संक्रांति",
      "संक्रांति पूजा विधि",
    ],
  },
  "vrat-calendar": {
    title: "व्रत कैलेंडर {year} — हिंदू व्रत और उपवास तिथियाँ, एकादशी से संक्रांति | इश्वरम",
    description:
      "हिंदू व्रत कैलेंडर {year} — एकादशी, पूर्णिमा, अमावस्या, प्रदोष, संकष्टी चतुर्थी, मासिक शिवरात्रि और संक्रांति की अगली तिथि, पूजा विधि लिंक के साथ। हर तिथि तिथि-गणना से, अनुमान नहीं।",
    keywords: [
      "व्रत कैलेंडर",
      "व्रत कैलेंडर {year}",
      "हिंदू व्रत कैलेंडर",
      "व्रत सूची {year}",
      "उपवास कैलेंडर",
      "एकादशी प्रदोष संकष्टी तिथि",
      "हिंदू व्रत तिथि",
      "व्रत त्योहार कैलेंडर",
    ],
  },
};

export default hi;

// ---------------------------------------------------------------------------
// Cookie consent banner copy (Hindi) — separate from PageMeta
// ---------------------------------------------------------------------------
import type { CookieConsentCopy } from "./en";

export const cookieConsentHi: CookieConsentCopy = {
  title: "Analytics विकल्प",
  body: "Optional analytics से Ishvaram बेहतर बनाने में मदद मिलती है।",
  acceptAll: "Allow",
  rejectAll: "No thanks",
  customize: "विकल्प देखें",
  customizeClose: "बंद करें",
  essentialHeading: "आवश्यक (हमेशा चालू)",
  essentialDetail:
    "Sentry error tracking — साइट को सुरक्षित रखता है। कोई व्यक्तिगत डेटा भारत से बाहर नहीं जाता।",
  analyticsHeading: "Analytics (वैकल्पिक)",
  analyticsDetail:
    "फर्स्ट-पार्टी analytics और marketing tags — हमें Kundali, Rashifal और Panchang tools बेहतर बनाने में मदद करते हैं।",
  ariaLabel: "Cookie सहमति",
};
